import { defaultEnvironment } from '../environment';
export class AppService {
  static environment = defaultEnvironment;
  static disableTracking = false;
}